import { Component, Input } from '@angular/core';

import { ContentTheme } from '../../models';

@Component({
  selector: 'wl-partial-media-card',
  templateUrl: './media-card.component.html',
  styleUrls: ['./media-card.component.ed.scss'],
  standalone: true,
})
export class MediaCardComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() grow = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() shadow = false;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() theme: ContentTheme = 'default';
}
